<template>
  <div>
    <b-card>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            Mis Suscripciones
          </h4>
          <div class="ml-auto">
            <b-button
              variant="primary"
              size="sm"
              class="ml-4"
              @click="query"
            >
              <feather-icon
                icon="RefreshCwIcon"
                size="14"
                class="mr-50"
              />
              Actualizar
            </b-button>
          </div>
        </div>
      </template>

      <b-table
        responsive
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="No hay suscripciones"
        head-variant="dark"
        striped
        hover
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner variant="primary" />
          </div>
        </template>

        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(status)="data">
          <b-badge
            pill
            :variant="
              data.item.status_p2p
                ? data.item.status_p2p.class
                : 'secondary'
            "
          >
            {{
              data.item.status_p2p
                ? data.item.status_p2p.estado
                : '-'
            }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-button
            v-if="
              data.item.status_p2p &&
                data.item.status_p2p.op_cancel
            "
            variant="danger"
            size="sm"
            @click="confirmCancel(data.item.idsuscription)"
          >
            Cancelar
          </b-button>
        </template>
      </b-table>
    </b-card>

    <b-modal
      id="modal-debit"
      ref="modal-debit"
      ok-only
      centered
      ok-title="Cerrar"
      size="lg"
      title="Autorización de Suscripción"
    >
      <debit :contract="contract" />
    </b-modal>
  </div>
</template>

<script>
import { BBadge, BButton, BCard, BSpinner, BTable } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Debit from '@/views/home/Debit.vue'

export default {
    components: { BCard, BTable, BButton, BBadge, BSpinner, Debit },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem('userData')),
            isBusy: false,
            items: [],
            fields: [
                { key: 'index', label: '#' },
                { key: 'codigo', label: 'Contrato' },
                { key: 'direccion', label: 'Dirección' },
                { key: 'apenom', label: 'Titular' },
                { key: 'fechaserver', label: 'Fecha' },
                { key: 'reference', label: 'Referencia' },
                { key: 'status', label: 'Estado' },
                { key: 'message', label: 'Mensaje' },
                { key: 'actions', label: 'Acciones' },
            ],
            contract: {},
        }
    },
    created() {
        this.query()
    },
    methods: {
        query() {
            this.isBusy = true
            this.$http
                .get('/suscription', {
                    params: { idusuario: this.userData.id },
                })
                .then((res) => {
                    this.items = res.data.data || []
                })
                .catch(() => {})
                .finally(() => {
                    this.isBusy = false
                })
        },

        confirmCancel(id) {
            this.$swal({
                title: 'Confirmación',
                text: '¿Seguro que desea cancelar la suscripción?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, cancelar',
                cancelButtonText: 'No',
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-secondary ml-1',
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) this.cancel(id)
            })
        },

        cancel(id) {
            this.$http
                .put(`/nuvei/suscription-cancel/${id}`, {
                    idusuario: this.userData.id,
                })
                .then(() => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Suscripción cancelada',
                            variant: 'success',
                            icon: 'CheckIcon',
                        },
                    })
                    this.query()
                })
                .catch(() => {})
        },
    },
}
</script>
